export default {
    root: ({ props }) => ({
        class: ['shadow-sm', { 'opacity-60 select-none pointer-events-none cursor-default': props.disabled }]
    }),
    button: ({ context, props }) => ({
        class: [
            'relative',
            // Font
            'text-sm',
            'leading-none',

            // Flex Alignment
            'inline-flex items-center align-bottom text-center',

            // Spacing
            'px-2.5 py-1.5',

            // Shape
            'ring-1',
            { 'ring-surface-200 dark:ring-neutral-600': !props.invalid },
            'first:rounded-l-md first:rounded-tr-none first:rounded-br-none',
            'last:rounded-tl-none last:rounded-bl-none last:rounded-r-md ',

            // Color
            {
                'bg-surface-0 dark:bg-neutral-700': !context.active,
                'text-surface-700 dark:text-white/80': !context.active,
                'bg-surface-100 dark:bg-primary-500': context.active,
                'text-surface-900 dark:text-white': context.active
            },

            // Shadow for active state
            { 'shadow-md shadow-primary-500/10 dark:shadow-primary-500/20': context.active },

            // Invalid State
            { 'ring-red-500 dark:ring-red-400': props.invalid },

            // States
            'focus:outline-none focus:outline-offset-0 focus:ring-primary-500 dark:focus:ring-primary-400 focus:z-10',
            {
                'hover:bg-surface-200': !context.active,
                'dark:hover:bg-primary-600': !context.active,
                'hover:bg-surface-200 dark:hover:bg-primary-600': context.active
            },
            { 'opacity-60 select-none pointer-events-none cursor-default': context.disabled },

            // Transition
            'transition duration-200',

            // Misc
            'cursor-pointer select-none overflow-hidden'
        ]
    }),
    label: {
        class: 'font-semibold'
    }
};
